import { useContext, useEffect } from 'react'
import { ViewerContext } from '../../context/ViewerContext'

const Viewer = () => {
  const { setIsViewerMounted } = useContext(ViewerContext)

  useEffect(() => {
    setIsViewerMounted(true)
    return () => setIsViewerMounted(false) // Resetear cuando se desmonte
  }, [])
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div
        style={{
          display: 'flex',
          padding: '1rem 2rem',
          position: 'absolute',
          zIndex: '1000',
          gap: '3rem',
        }}
      ></div>

      <div id="forgeViewer" className="forge-viewer" />
    </div>
  )
}

export default Viewer
